import { DataTypeWithOperatorNS } from 'src/app/misc/saved-searches/models/saved-search.static';
import { prepareSavedSearchRuleValues } from 'src/app/misc/saved-searches/helpers/prepare-saved-search-rule-values.helper';
import { WorkflowActionNames, WorkflowMessages } from './../../../../misc/workflow/models/workflow.static';
import { WorkflowModelsNS } from 'src/app/misc/workflow/models/add-update-workflow.models';
import { AppMainService } from './../../../../app-main.service';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { ChannelN } from "../../models/channel.model";
import { AccountModuleId } from './../../constants/modules.constant';
import { SavedSearchNS } from "../../../../misc/saved-searches/models/saved-search.models";
import { LazyLoadEvent, MessageService } from "primeng/api";
import { FormControl } from "@angular/forms";
import { WorkflowService } from '../../../../misc/workflow/services/workflow.service';
import { ParseHelper } from '../../parse.helper';
import { Status } from 'src/app/models/statusEnums';
import { prepareSavedSearchAddEditFilter } from 'src/app/misc/saved-searches/helpers/prepare-saved-searh-filter.helper';
import { AppMainComponent } from 'src/app/app.main.component';
import { ObjectNames } from 'src/app/shared/constants';

@Component({
    selector: 'app-shared-mass-edit-history',
    styleUrls: ['./shared-mass-edit-history.component.scss'],
    templateUrl: './shared-mass-edit-history.component.html',
})
export class SharedMassEditHistoryComponent implements OnDestroy, OnChanges {

    @Input() selectedChannel: ChannelN;
    @Input() selectedModuleId: number = AccountModuleId;
    @Input() selectedModuleName: string = 'Account';
    @Input() historySearchValue: string = "";
    @Input() historyRefresh: boolean = false;

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    workflowExecutionStatus = WorkflowModelsNS.WorkflowExecutionStatus;
    listCols: SavedSearchNS.IColumn[] = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: true, moveable: false, dataType: 'number' },
        { field: 'sequenceNumber', header: 'Id. No.', show: true, value: '', checked: true, order: true, moveable: false, dataType: 'string' },
        { field: 'typeName', header: 'Rule Selection', show: true, value: '', checked: true, order: true, moveable: false, dataType: 'string' },
        { field: 'createdDate', header: 'Created Date', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'date' },
        { field: 'createdByName', header: 'Created By', show: true, value: '', checked: true, order: false, moveable: false, dataType: 'string' },
        { field: 'executionStatusName', header: 'Execution Status',show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' }
    ];

    searchControl = new FormControl();
    moduleSearchValue = '';
    gridState: any = {};

    workflowListResults: any[] = [];
    noWfFindOrLoadingText = 'Loading...';
    pageNumber: number = 1;
    pageSize: number = 15;
    totalRecords: number = 0;
    tableShowMore: number[] = [15, 30, 50, 100];
    first: number = 0;

    selectedWorkflow: any;
    listCallingFirstTime: boolean = true;

    constructor(
        private app: AppMainComponent,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private workflowService: WorkflowService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['historySearchValue']){
            this.historySearchValue = changes['historySearchValue']?.currentValue||"";
            !this.listCallingFirstTime && this.refreshList();
        }

        if(changes['historyRefresh'] && changes['historyRefresh']?.currentValue){
            this.historyRefresh = changes['historyRefresh']?.currentValue||"";
            !this.listCallingFirstTime && this.refreshList();
        }
    }

    refreshList(){
        this.first = 0;
        this.getAllWorkflowList(1, 15);
    }

    onFilterChange(event: LazyLoadEvent): void {
        const filters: any[] = [];
        for (const filterName in event.filters) {
            filters.push({
                field: filterName,
                value: event.filters[filterName].value
            });
        }
        this.gridState['filters'] = filters
    }

    getWorkflowListByFilter(event: LazyLoadEvent): void {
        if (!event.sortField && !event.filters) {
            if (event.first == 0 && event.rows == 15) {
                this.getAllWorkflowList(1, 15);
                return;
            }
        }

        const pageSize: number = event.rows;
        const pageNumber: number = (event.first / event.rows) + 1;
        //if sort exist
        if (event.sortField) {
            const temp = {
                field: event.sortField,
                order: event.sortOrder
            }
            this.gridState['sort'] = temp;
        }
        //if column filter exist
        if (event.filters) {
            this.onFilterChange(event);
        }

        this.getAllWorkflowList(pageNumber, pageSize);
    }

    getAllWorkflowList(pageNumber: number, pageSize: number){

        this.pageNumber = pageNumber;
        const options: any = {};

        // apply field Filter
        if (this.gridState && this.gridState.filters && this.gridState.filters.length) {
            const filterColumns = [];
            this.gridState.filters.map(columnObj => {
                filterColumns.push(columnObj.field);
            });
            let searchValue = this.gridState.filters && this.gridState.filters[0] && this.gridState.filters[0].value ? this.gridState.filters[0].value : '';
            options.filter = {
                field: filterColumns.join(','),
                value: searchValue
            }
        }

        // apply sorting
        if (this.gridState && this.gridState.sort) {
            options.sort = {
                SortBy: this.gridState.sort.field,
                IsAscending: this.gridState.sort.order === 1 ? true : false
            }
        }

        options.moduleSearchValue = this.historySearchValue.length ? this.historySearchValue.trim() : '';
        this.appMainService.isShowSpinner('getWorkflowList');
        this.workflowService.getAllMassEditList(this.selectedModuleId, this.selectedChannel?.id, pageNumber, pageSize, options).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) =>{
                this.appMainService.isHideSpinner('getWorkflowList');

                let data = response.body == null ? [] : response.body;
                let headers = JSON.parse(response.headers.get('X-Pagination'));
                headers = headers == null ? [] : headers;
                this.totalRecords = headers['TotalCount'] || 0;

                this.workflowListResults = data.map(workflowDetails=>{
                    return {
                        ...workflowDetails,
                        typeName: workflowDetails.ruleTypeName,
                        executionStatusName: this.workflowExecutionStatus[workflowDetails.executionStatus]
                    }
                });
                this.listCallingFirstTime = false;
                this.noWfFindOrLoadingText = 'No Mass Edit History Found.';
            },
            error: (error) => {
                this.listCallingFirstTime = false;
                this.appMainService.isHideSpinner('getWorkflowList');
                this.noWfFindOrLoadingText = 'No Mass Edit History Found.';
            }
        })
    }

    onRowSelect(event) {
        this.loadWorkflowAndHistoryTogether(this.selectedWorkflow?.id);
    }

    onRowUnselect(event){

    }

    //#region workflow details with history
    workflowTriggerTypeEnum = WorkflowModelsNS.TriggerTypeEnum;
    workflowDetails: WorkflowModelsNS.WorkflowDetails;
    conditionGroup: WorkflowModelsNS.WorkflowAddedEditConditionGroup[] = [];
    ruleData: SavedSearchNS.IRuleList[] = [];
    choicesDD: SavedSearchNS.IChoice[] = [
        { id: 1, name: "And" },
        { id: 2, name: "Or" },
    ];

    //History Dialog
    selectedDetailsCols: SavedSearchNS.IColumn[] = [];
    displayHistoryDetails: boolean = false;
    historyConditionGroup: WorkflowModelsNS.WorkflowAddedEditConditionGroup[] = [];
    actionHistoryResults: any[] = [];

    //View Popup
    accountDetailsRouteNavigationFor: string[] = ['Account','Lead','Opportunity'];
    displayAccountViewEdit: boolean = false;
    selectedAccountId: number = 0;
    displayLeadViewEdit: boolean = false;
    selectedLeadId: number = 0;
    displayOpportunityViewEdit: boolean = false;
    opportunityEditViewId: number = 0;

    displayDetailPopup = false;
    popupDataId: number = 0;
    popupModuleType: string = '';
    popupHeader: string = '';

    loadWorkflowAndHistoryTogether(workflowId: number) {
        this.appMainService.isShowSpinner('LoadWorkflowAndHistoryTogether');

        // Define the two API calls
        const workflowDetails$ = this.workflowService.getWorkflowById(workflowId);
        const workflowHistory$ = this.workflowService.getWorkflowExecutionHistory(workflowId, 1, 15);

        // Use forkJoin to run both API calls together
        forkJoin({
            workflowDetails: workflowDetails$,
            workflowHistory: workflowHistory$
        }).pipe(takeUntil(this.ngUnsubscribe$))  // Ensure to unsubscribe when necessary
          .subscribe({
            next: (results) => {
                this.appMainService.isHideSpinner('LoadWorkflowAndHistoryTogether');

                // Results from both API calls
                const workflowDetails = results.workflowDetails;
                const workflowHistoryResponse = results.workflowHistory;

                // Now you can process the results together
                this.workflowDetails = workflowDetails;
                this.conditionGroup = [];
                this.setWorkflowEditDetails(); // Do something with workflow details

                // Process the workflow history response
                let data = workflowHistoryResponse.body == null ? [] : workflowHistoryResponse.body;
                if(data?.length>0){
                    this.openHistoryDetails(data[0])
                }
            },
            error: (error) => {
                this.appMainService.isHideSpinner('LoadWorkflowAndHistoryTogether');
                this.messageService.add({
                    severity: WorkflowMessages.error.toLowerCase(),
                    summary: WorkflowMessages.error,
                    detail: WorkflowMessages.detailsErrorMsg
                });
            }
        });
    }

    setWorkflowEditDetails(){
        this.workflowDetails.workflowConditions.filter(c=>c.statusId==Status.Active).sort((a, b)=> b.order - a.order).map((addedCondition, index)=>{

            const constionRefId: number = this.conditionGroup.length>0 ? this.conditionGroup[0].id + 1 : 1;
            const addedInstantAction = addedCondition?.workflowActions.find(actionDetails=>actionDetails.occurrenceType===WorkflowModelsNS.OccurrenceTypeEnum.INSTANT && actionDetails.statusId==Status.Active);
            const conditionData: WorkflowModelsNS.WorkflowAddedEditConditionGroup = {
                id: constionRefId,
                conditionId: addedCondition.id,
                conditionNumber: index+1,
                statusId: addedCondition?.statusId||1,
                type: addedCondition.isMannualCondition ? 'manual' : 'savedsearch',
                savedSearchId: addedCondition.saveSearchId,
                isCombinational: addedCondition?.savedSearchInfo?.isCombinational||false,
                ruleCombination: addedCondition?.savedSearchInfo?.ruleCombination||"",
                validData: true,
                errorMsg: "",
                ruleData: [],
                instantActions: {
                    ...addedInstantAction,
                    executionOrders: ParseHelper.DeepCopy(WorkflowModelsNS.WorkflowActionDefaultOrders),
                    workflowActionTasks: [],
                    workflowActionEmails: [],
                    workflowActionUpdateFields: [],
                    workflowActionCreateRecords: [],
                    workflowActionUpdateRecords: [],
                    workflowActionConvertToInvoices: [],
                    workflowActionDeleteRecords: [],
                    workflowActionApprovals: []
                },
                timeDependentActions: []
            }

            addedCondition.workflowActions.filter(actionDetails=>actionDetails.statusId==Status.Active).map((actionDetails)=>{

                if(actionDetails?.workflowActionTasks){
                    actionDetails.workflowActionTasks = actionDetails.workflowActionTasks.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionEmails){
                    actionDetails.workflowActionEmails = actionDetails.workflowActionEmails.filter(email=> email.statusId==Status.Active)||[];

                    actionDetails.workflowActionEmails.map(emailDetails=>{

                        if(emailDetails.workflowEmailAttachments?.length>0){
                            const addedAttachments: WorkflowModelsNS.EmailTemplateAttachments[] = [];
                            emailDetails.workflowEmailAttachments.map(attachmentDetails=>{
                                attachmentDetails = {
                                    ...attachmentDetails,
                                    oldAttachment: attachmentDetails.attachment,
                                    attachment: null,
                                }

                                addedAttachments.push(attachmentDetails);
                            })

                            emailDetails.workflowEmailAttachments = addedAttachments;
                        }

                    })
                }

                if(actionDetails?.workflowActionUpdateFields){
                    actionDetails.workflowActionUpdateFields = actionDetails.workflowActionUpdateFields.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionCreateRecords){
                    actionDetails.workflowActionCreateRecords = actionDetails.workflowActionCreateRecords.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionUpdateRecords){
                    actionDetails.workflowActionUpdateRecords = actionDetails.workflowActionUpdateRecords.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionApprovals){
                    actionDetails.workflowActionApprovals = actionDetails.workflowActionApprovals.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionConvertToInvoices){
                    actionDetails.workflowActionConvertToInvoices = actionDetails.workflowActionConvertToInvoices.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails?.workflowActionDeleteRecords){
                    actionDetails.workflowActionDeleteRecords = actionDetails.workflowActionDeleteRecords.filter(task=> task.statusId==Status.Active)||[];
                }

                if(actionDetails.occurrenceType===WorkflowModelsNS.OccurrenceTypeEnum.INSTANT){
                    if(actionDetails?.workflowActionTasks?.length>0)
                    conditionData.instantActions.workflowActionTasks = [...conditionData.instantActions.workflowActionTasks,...actionDetails.workflowActionTasks];

                    if(actionDetails?.workflowActionEmails?.length>0)
                    conditionData.instantActions.workflowActionEmails = [...conditionData.instantActions.workflowActionEmails,...actionDetails.workflowActionEmails];

                    if(actionDetails?.workflowActionUpdateFields?.length>0)
                    conditionData.instantActions.workflowActionUpdateFields = [...conditionData.instantActions.workflowActionUpdateFields,...actionDetails.workflowActionUpdateFields];

                    if(actionDetails?.workflowActionCreateRecords?.length>0)
                    conditionData.instantActions.workflowActionCreateRecords = [...conditionData.instantActions.workflowActionCreateRecords,...actionDetails.workflowActionCreateRecords];

                    if(actionDetails?.workflowActionUpdateRecords?.length>0)
                    conditionData.instantActions.workflowActionUpdateRecords = [...conditionData.instantActions.workflowActionUpdateRecords,...actionDetails.workflowActionUpdateRecords];

                    if(actionDetails?.workflowActionApprovals?.length>0)
                    conditionData.instantActions.workflowActionApprovals = [...conditionData.instantActions.workflowActionApprovals,...actionDetails.workflowActionApprovals];

                    if(actionDetails?.workflowActionConvertToInvoices?.length>0)
                    conditionData.instantActions.workflowActionConvertToInvoices = [...conditionData.instantActions.workflowActionConvertToInvoices,...actionDetails.workflowActionConvertToInvoices];

                    if(actionDetails?.workflowActionDeleteRecords?.length>0)
                    conditionData.instantActions.workflowActionDeleteRecords = [...conditionData.instantActions.workflowActionDeleteRecords,...actionDetails.workflowActionDeleteRecords];
                }else{
                    const action: any = actionDetails;
                    actionDetails.occurrenceValue = Math.abs(actionDetails.occurrenceValue);

                    conditionData.timeDependentActions.push({
                        ...action
                    });
                }
            })

            if(addedCondition?.savedSearchInfo?.savedSearchRule?.length>0){
                conditionData.ruleData = addedCondition.savedSearchInfo.savedSearchRule.map((rule: any)=>{

                    let choice = this.choicesDD.find(x => x.name == rule.operator);
                    let eachRule: SavedSearchNS.IRuleList = {
                        id: rule.id,
                        ruleNo: rule?.ruleNo,
                        module: null,
                        subModule: null,
                        template: { id: rule.templateId, templateName: rule.templateName, objectId: rule.objectId, channelId: 0, channelName: '', isActive: true },
                        filter: prepareSavedSearchAddEditFilter(rule),
                        operator: { id: 1, name: rule.equation },
                        value: rule.values,
                        value2: null,
                        choice: choice,
                        isMainModule: rule.isMainModule,
                        dataTypeWithOperator: this.getOperatorByDataTypeAddEdit(rule.dataType, rule.equation),
                        valueLists: [],
                        treeValueLists: [],
                        objectId: rule.objectId,
                        objectName: rule.objectName,
                        valueRefId: rule.valueRefId,
                        groupLabel: "",
                        groupChildren: "",
                        group: false,
                        filtersDD: [],
                        canEdit: true,
                        accountChannel: null,
                        compareWithField: rule?.compareWithField||false,
                        comparisonCriteria: rule?.comparisonCriteria||null,
                        comparisonCriteriaLabel: rule?.comparisonCriteriaLabel||null,
                        comparisonCriteriaParentLabel: rule?.comparisonCriteriaParentLabel||null,
                        isCustomComparisonCriteria: rule?.isCustomComparisonCriteria||false,
                        comparisonCriteriaObject: rule?.comparisonCriteriaObject||null,
                        customAttributeObjectId: rule?.customAttributeObjectId||null,
                        comparisonCustomAttributeObjectId: rule?.comparisonCustomAttributeObjectId||null,
                    };
                    //****Prepare Value
                    // console.log(eachRule)
                    const { value, value2 } = prepareSavedSearchRuleValues(eachRule, this.app.usersList);
                    eachRule.value = value;
                    eachRule.value2 = value2;
                    return eachRule;
                })
            }else{
                conditionData.ruleData = [];
            }


            conditionData.instantActions.executionOrders.map(actionOrder=>{
                if(conditionData.instantActions?.[actionOrder.code]?.length>0){
                    actionOrder.executionOrder = conditionData.instantActions?.[actionOrder.code][0].executionOrder||0;
                }
            });
            conditionData.instantActions.executionOrders = conditionData.instantActions.executionOrders.sort((a,b)=> a.executionOrder - b.executionOrder);

            conditionData.timeDependentActions.map(timeDependentAction=>{
                timeDependentAction.executionOrders.map(actionOrder=>{
                    if(timeDependentAction?.[actionOrder.code]?.length>0){
                        actionOrder.executionOrder = timeDependentAction?.[actionOrder.code][0].executionOrder||0;
                    }
                });
                timeDependentAction.executionOrders = timeDependentAction.executionOrders.sort((a,b)=> a.executionOrder - b.executionOrder);
            });

            if(this.conditionGroup.length>0){
                this.conditionGroup.unshift(conditionData)
            }else{
                this.conditionGroup.push(conditionData)
            }


        })
    }

    getOperatorByDataTypeAddEdit(dataType: string, operator: string): DataTypeWithOperatorNS.ISavedSearchDataTypeWithOperator {
        let selectedDataTypeAndOperator = DataTypeWithOperatorNS.SavedSearchDataTypeWithOperator.find(x => x.DataType == dataType && x.Operator == operator);
        return selectedDataTypeAndOperator;
    }

    checkActions(actionDetails: any){
        return WorkflowModelsNS.WorkflowActionDefaultOrders.some(action=> actionDetails?.[action.code]?.length>0);
    }

    openHistoryDetails(historyDetails: WorkflowModelsNS.WorkflowHistoryDetails){
        const actionsList: string[] = WorkflowActionNames;
        const historyConditionGroup = this.conditionGroup.filter(condition=> condition.conditionId==historyDetails.workflowConditionId)||[];
        this.historyConditionGroup = ParseHelper.DeepCopy(historyConditionGroup);
        // this.historyConditionGroup.map(addedCondition=>{
        //     if(addedCondition.instantActions.id==historyDetails.workflowActionId){
        //         actionsList.map(actionName=>{
        //             if(addedCondition.instantActions?.[actionName] && addedCondition.instantActions?.[actionName]?.length){
        //                 addedCondition.instantActions[actionName] =  addedCondition.instantActions[actionName].filter(c=> (actionName === "workflowActionUpdateFields" && c.objectId) ? c.objectId === historyDetails.objectId : c.id === historyDetails.workflowActionTaskId);
        //             }
        //         });
        //     }else{
        //         addedCondition.instantActions = null;
        //     }

        //     addedCondition.timeDependentActions = addedCondition.timeDependentActions.filter(c=>c.id==historyDetails.workflowActionId);

        //     if(addedCondition.timeDependentActions.length>0){
        //         addedCondition.timeDependentActions.map(actionDetails=>{
        //             actionsList.map(actionName=>{
        //                 if(actionDetails?.[actionName] && actionDetails?.[actionName]?.length){
        //                     actionDetails[actionName] =  actionDetails[actionName].filter(c=> (actionName === "workflowActionUpdateFields" && c.objectId) ? c.objectId === historyDetails.objectId : c.id === historyDetails.workflowActionTaskId);
        //                 }
        //             });
        //         })
        //     }else{
        //         addedCondition.timeDependentActions = null;
        //     }
        // })

        this.actionHistoryResults = historyDetails?.taskData ? JSON.parse(historyDetails?.taskData)?.Result||[] : [];

        let navigationFields: string[] = [];

        if(['Lead','Account'].includes(this.workflowDetails?.objectName)){
            navigationFields = ['Lead Name','Account Name','Sales Order No','Estimate No','Invoice No','Invoice','CreditMemo','Estimate','SalesOrder','ConSONo','ConInvNo','Credit Memo'];
        }else if(['Opportunity'].includes(this.workflowDetails?.objectName)){
            navigationFields = ['name','Opportunity Name'];
        }else if([ObjectNames.SALES_ORDER.toString()].includes(this.workflowDetails?.objectName)){
            navigationFields = ['Sales Order No.'];
        }else{
            navigationFields = ['Item No','Invoice No.','Estimate No.'];
        }

        this.generateHistoryDetailsColumns(navigationFields,historyDetails);
        this.displayHistoryDetails = true;
    }

    generateHistoryDetailsColumns(navigationFields: string[], historyDetails: any){
        if(this.actionHistoryResults?.length>0){
            const historyDetailsObject = this.actionHistoryResults[0];
            const columns: SavedSearchNS.IColumn[] = [];
            const globalThis = this;


            if(historyDetails?.savedSearchColumnSetting){
                this.selectedDetailsCols = this.getColumnSettingsForTable(historyDetails?.savedSearchColumnSetting, navigationFields);

                Object.keys(historyDetailsObject).forEach(function(key, index) {
                    const fieldCheck = globalThis.selectedDetailsCols.find(x=> x.field==key);
                    if(fieldCheck){
                        fieldCheck.show = true;
                    }
                });
            }else{
                Object.keys(historyDetailsObject).forEach(function(key, index) {
                    if(!['id','trans_id'].includes(key.trim().toLowerCase())){
                        columns.push({
                            field: key,
                            name: key,
                            header: globalThis.prepareColumnNameFromField(key),
                            show: true,
                            value: navigationFields.includes(key.trim()) ? 'name' : key,
                            checked: false,
                            order: false,
                            moveable: false,
                            dataType: ['CreatedDate','UpdatedDate','Created Date','Updated Date','Last Updated Date','Close Date',
                                        'expectedDate','createdDate','Invoice Date','Invoice Due Date','Estimate Date','Expiration Date','Trans Created Date','Trans Last Updated Date'].includes(key.trim()) ? 'date' : 'string'
                        });
                    }
                });

                this.selectedDetailsCols = columns;
            }
        }
    }

    getColumnSettingsForTable(selectedColums: SavedSearchNS.SavedSearchColumnSetting[], navigationFields: string[]): any[] {
        let columns: SavedSearchNS.IColumn[] = [];

        if (selectedColums) {
            let i = 1;
            selectedColums?.map(f => {
                f?.fields?.map(x => {
                    //nested field
                    if (x?.nestedFields?.length > 0) {
                        x.nestedFields?.map(nestObj => {
                            columns.push(
                                {
                                    field: this.prepareColumnNameFromCriteria(nestObj.criteriaUsed),
                                    name: (nestObj?.name||nestObj?.fieldName||'').trim(),
                                    header: `${x?.name||x?.fieldName}: ${nestObj.labelName}`,
                                    dataType: nestObj.fieldDataType == 'DateTime' ? 'date' : (nestObj.fieldDataType == 'Number' || nestObj.fieldDataType == 'Decimal') && nestObj.fieldName != 'Qty' ? 'number' : nestObj.fieldDataType == 'Money' ? 'currencySymbol' : 'string',
                                    show: false,
                                    value: navigationFields.includes((nestObj?.name||nestObj?.fieldName||'').trim()) ? 'name' : null,
                                    checked: nestObj.isSelected,
                                    order: false,
                                    moveable: false,
                                });
                            i = i + 1;
                        });
                    }
                    else {
                        columns.push(
                            {
                                field: this.prepareColumnNameFromCriteria(x.criteriaUsed),
                                name: (x?.name||x?.fieldName||'').trim(),
                                header: x.labelName,
                                dataType: x.fieldDataType == 'DateTime' ? 'date' : (x.fieldDataType == 'Number' || x.fieldDataType == 'Decimal') ? 'number' : x.fieldDataType == 'Money' ? 'currencySymbol' : 'string',
                                show: false,
                                value: navigationFields.includes((x?.name||x?.fieldName||'').trim()) ? 'name' : null,
                                checked: x.isSelected,
                                order: false,
                                moveable: false,
                            });
                        i = i + 1;
                    }
                });
            });

            const defaultColumns: string[] = ['ConSONo','ConInvNo','Invoice','CreditMemo','Estimate','SalesOrder','CreatedDate','UpdatedDate','Status','Reason','Comment'];

            defaultColumns.map(field=>{
                columns.push({
                    field: field,
                    name: field,
                    header: field,
                    show: false,
                    value: navigationFields.includes(field) ? 'name' : null,
                    checked: false,
                    order: false,
                    moveable: false,
                    dataType: ['CreatedDate','UpdatedDate'].includes(field.trim()) ? 'date' : 'string'
                });
            });
        }

        return columns;
    }

    prepareColumnNameFromCriteria(str?: string) {
        return str?.length > 0 ? str[0].toLocaleLowerCase() + str.slice(1) : str;
    }

    prepareColumnNameFromField(str?: string){
        return str?.length > 0 ? str[0].toLocaleUpperCase()+str.slice(1) : str;
    }

    onRouteNavigation(rowData: any, field: string, fieldName: string) {
        if(this.accountDetailsRouteNavigationFor.includes(this.workflowDetails?.objectName)){
            this.setPopUpLinkData(rowData);
        }
    }

    setPopUpLinkData(rowData: any) {
        const moduleName = this.workflowDetails.objectName;
        this.popupDataId = rowData?.Id||rowData?.id||0;
        switch (moduleName) {
            case 'Lead':
                this.openLeadViewEdit(this.popupDataId);
                break;
            case 'Account':
                this.openAccountViewEdit(this.popupDataId);
                break;
            case 'Opportunity':
                this.openOpportunityViewEdit(this.popupDataId);
                break;
            default:
                break;
        }
    }

    openAccountViewEdit(accountId: number) {
        this.displayAccountViewEdit = true;
        this.selectedAccountId = accountId;
    }

    openLeadViewEdit(leadId: number) {
        this.displayLeadViewEdit = true;
        this.selectedLeadId = leadId;
    }

    openOpportunityViewEdit(opportunityId: number) {
        this.displayOpportunityViewEdit = true;
        this.opportunityEditViewId = opportunityId;
    }

    closeViewPopup(){
        this.displayAccountViewEdit = false;
        this.displayLeadViewEdit = false;
        this.displayOpportunityViewEdit = false;
    }

    historyDialogClose(){
        this.displayHistoryDetails = false;
    }

    //#endregion

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}

